import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import 'bulma/css/bulma.min.css';
import { InfoService } from '../../../services/site/InfoService';
// Import SCSS: import './sds_legal_styles.scss';

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } }
};

// Animated section wrapper
const AnimatedSection: React.FC<{ 
  children: React.ReactNode; 
  className?: string;
}> = ({ children, className = '' }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={fadeInUp}
      className={className}
    >
      {children}
    </motion.div>
  );
};

// ============================================
// PRIVACY POLICY COMPONENT
// ============================================
export const ShippingPolicy: React.FC = () => {
  return (
    <div className="sds_legal-wrapper">
      {/* SEO Meta */}
      <div style={{ display: 'none' }}>
        <h1>Cancellation & Refund Policy</h1>
        <meta name="description" content="Cancellation & Refund Policy" />
      </div>

      <div className="container">
        <AnimatedSection className="sds_legal-header section">
          <div className="has-text-centered">
           Last updated on Oct 17 2025

HDT SOLUTIONS LLP believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. Under this policy:

Cancellations will be considered only if the request is made within 2 days of placing the order. However, the cancellation request may not be entertained if the orders have been communicated to the vendors/merchants and they have initiated the process of shipping them.

HDT SOLUTIONS LLP does not accept cancellation requests for perishable items like flowers, eatables etc. However, refund/replacement can be made if the customer establishes that the quality of product delivered is not good.

In case of receipt of damaged or defective items please report the same to our Customer Service team. The request will, however, be entertained once the merchant has checked and determined the same at his own end. This should be reported within 2 days of receipt of the products.

In case you feel that the product received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within 2 days of receiving the product. The Customer Service Team after looking into your complaint will take an appropriate decision.

In case of complaints regarding products that come with a warranty from manufacturers, please refer the issue to them.

In case of any Refunds approved by the HDT SOLUTIONS LLP, it'll take 3-5 days for the refund to be processed to the end customer.
          </div>
        </AnimatedSection>

        
      </div>
    </div>
  );
};
export default ShippingPolicy;